import { render } from "./ConcordanceSearch.vue?vue&type=template&id=1a53f606&scoped=true&ts=true"
import script from "./ConcordanceSearch.vue?vue&type=script&lang=ts"
export * from "./ConcordanceSearch.vue?vue&type=script&lang=ts"

import "./ConcordanceSearch.vue?vue&type=style&index=0&id=1a53f606&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a53f606"]])

export default __exports__